import { render, staticRenderFns } from "./RegisterViewTemplate.vue?vue&type=template&id=23a752b4&scoped=true&"
import script from "./RegisterViewTemplate.vue?vue&type=script&lang=js&"
export * from "./RegisterViewTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a752b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
installComponents(component, {VApp})
